<template>
  <div class="background-img">
    <div id="homesection" class="wrapper">
      <b-container>
        <b-row align-h="center">
          <b-col lg="5" md="12">
            <b-img v-bind:src="logoseti" fluid-grow class="logo-seti"></b-img>
          </b-col>
        </b-row>
        <b-row class="text-edit">
          <b-col class="col-12">
            <p>
              {{ $t("semanaTec") }}
              <br />
              {{ $t("local") }}
            </p>
          </b-col>
        </b-row>
        <b-row class="text-edit-data">
          <b-col class="col-12">
            <p>{{ $t("data") }}</p>
          </b-col>
        </b-row>
        <b-row align-h="center">
          <b-col class="button-edit col-6 col-lg-3">
            <b-button href="/login" class="btn-hover color-1">{{
              $t("entrarButton")
            }}</b-button>
          </b-col>
          <b-col class="button-edit col-6 col-lg-3">
            <b-button
              target="_blank"
              href="https://forms.gle/yvWq4ZdHrjPjvoiD9"
              class="btn-hover color-1"
              >{{ $t("feedbackButton") }}</b-button
            >
          </b-col>
        </b-row>
      </b-container>
    </div>

    <b-container>
      <b-row>
        <b-col class="col-12">
          <b-img
            v-bind:src="arrowdown"
            class="arrow-edit"
            @click="scrollToSobre()"
          ></b-img>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      logoseti: require("../assets/Logo-Seti/logo_seti.png"),
      arrowdown: require("../assets/Home/arrow.svg"),
    };
  },
  methods: {
    scrollToSobre() {
      var distancia = document.getElementById("sobre").offsetTop;
      var distanciaReal = distancia - window.innerHeight * 0.1;

      window.scrollTo({
        behavior: "smooth",
        top: distanciaReal,
      });
    },
  },
};
</script>

<style scoped>
.background-img {
  background-image: url("../assets/Home/section_home_2.png");
  background-size: cover;
  background-position: center;
  max-width: 100%;
  scroll-behavior: smooth;
  transition: transform 0.4s;
}

.background-img:hover {
  animation-duration: 6s;
  animation-iteration-count: infinite;
  transform: scale(0.99);
  moz-transition: all 3s ease-in-out;
  -o-transition: all 3s ease-in-out;
  -webkit-transition: all 3s ease-in-out;
  transition: all 3s ease-in-out;
}

.icone {
  animation-name: spin;
  animation-duration: 4s;
  animation-iteration-count: infinite;
}

.text-edit {
  color: #0a0a0a;
  font-family: Roboto;
  display: flex;
  justify-content: center;
  flex-direction: row;
  font-size: 16px;
  font-weight: 300;
}

.text-edit-data {
  color: #0a0a0a;
  font-family: Roboto;
  display: flex;
  justify-content: center;
  flex-direction: row;
  font-size: 20px;
  font-weight: 500;
}

.button-edit {
  display: flex;
  justify-content: center;
  flex-direction: row;
  padding-top: 1em;
}

.btn-hover {
  width: 50em;
  border: none;
  background-size: 300% 100%;

  moz-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}

.btn-hover:hover {
  background-position: 100% 0;
  moz-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}

.btn-hover:focus {
  outline: none;
}

.btn-hover.color-1 {
  background-image: linear-gradient(to right, #ffc107, #ff0000, #ff0068);
  box-shadow: 0 4px 15px 0 rgba(252, 104, 110, 0.75);
}

.arrow-edit {
  padding-top: 2rem;
  cursor: pointer;
  width: 3rem;
  margin-top: -9rem;
  transition: transform 0.4s;
}

.arrow-edit:hover {
  animation-name: example;
  animation-duration: 6s;
  animation-iteration-count: infinite;
  transform: scale(1.1);
  moz-transition: all 3s ease-in-out;
  -o-transition: all 3s ease-in-out;
  -webkit-transition: all 3s ease-in-out;
  transition: all 3s ease-in-out;
}

@keyframes example {
  0% {
    transform: translateY(5px);
  }
  25% {
    transform: translateY(-5px);
  }
  50% {
    transform: translateY(4px);
  }
  75% {
    transform: translateY(-4px);
  }
  100% {
    transform: translateY(4px);
  }
}

.wrapper {
  height: 100vh;
  min-height: 100%;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
}

@media screen and (max-width: 991px) {
  .background-img {
    background-color: #ffffff;
    background-size: cover;
    max-width: 60%;
    background-image: none;
    margin: 0 auto;
  }
}

@media screen and (max-width: 768px) {
  .background-img {
    background-color: #ffffff;
    background-size: cover;
    max-width: 100%;
    background-image: none;
    margin: 0 auto;
  }
}
</style>
